import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopBar from "../topbar/TopBar";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from 'dompurify';
import SearchWithAPI from "../common/searchbox/searchbox.js";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import AsyncSelect from "react-select/async";
import { ReactComponent as BackIcon } from "../../assets/svg/nav-prev.svg";
import { createWhatsappTemplateApi, getWhatsappTemplateDetailsApi, updateWhatsappTemplateApi } from "../modal-dialog/setup-api.js";
import { ReactComponent as UploadIcon } from "../../assets/svg/upload_btn.svg";
import deleteIcon from "../../assets/svg/delete-icon.svg";
export const WhatsAppTemplateCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, } = location.state || {};


  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "0px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "618px",
      height: "100vh",
      overflowY: "auto",
    },
  };


  const [loading, setLoading] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [category, setCategory] = useState("");
  const [language, setLanguage] = useState("");
  const [headerType, setHeaderType] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [headerUpload, setHeaderUpload] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [footerText, setFooterText] = useState("");
  const [buttonName, setButtonName] = useState("");
  const [buttonsList, setButtonsList] = useState([]);
  const [base64File, setBase64File] = useState(null);
  const [urlImage, setUrlImage] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);


  const [validations, setValidations] = useState({
    "name": "",
    "category": "",
    "language": "",
    "bodytext": "",
    "header_type": "",
    "header_text": "",
    "header_upload": "",
    "footer_text": "",
    "quickactions": "",
  });
  function convertTo12Hour(time24) {
    const [hour, minute] = time24.split(':');
    const h = parseInt(hour);
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 || 12; // convert 0 to 12
    const formattedHour = hour12.toString().padStart(2, '0');
    const formattedMinute = minute.toString().padStart(2, '0');
    return `${formattedHour}:${formattedMinute} ${suffix}`;
  }
  useEffect(() => {
    if (id != null) {
      getWhatsappTemplateDetails()
    }
  }, []);

  const getWhatsappTemplateDetails = async () => {
    try {
      const response = await getWhatsappTemplateDetailsApi(id);
      if (response.success === true) {
        console.log(response)
        var whatsappTempDetails = response.template;
        console.log(whatsappTempDetails)
        setTemplateName(whatsappTempDetails.name ?? '')
        setCategory(whatsappTempDetails.category ?? '')
        setLanguage(whatsappTempDetails.language ?? '')
        setHeaderType(whatsappTempDetails.header_type ?? '')
        setHeaderText(whatsappTempDetails.header_text ?? '')
        setBodyText(whatsappTempDetails.bodytext ?? '')
        setFooterText(whatsappTempDetails.footer_text ?? '')
        setButtonsList(whatsappTempDetails.quickactions.map((item) => ({
          "id": item.id ?? 0,
          "button_type": item.button_type ?? '',
          'callActionType': item.button_type === 'Call to action' ? item.call_button === "" && item.call_number === "" ? 'Visit Website' : 'Call Phone' : '',
          "button_text": item.button_text ?? '',
          "visit_website": item.visit_website ?? '',
          "call_button": item.call_button ?? '',
          "call_number": item.call_number ?? '',
          "url_type": item.url_type ?? '',
          "url_value": item.url_value ?? '',
        })) ?? [])
        if (whatsappTempDetails.quickactions?.length > 0) {
          console.log("btn type", whatsappTempDetails.quickactions[0].button_type)
          setButtonName(whatsappTempDetails.quickactions[0].button_type)
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const submitWhatsappTemplate = async () => {

    const dataBeforeSanitize = {
      "name": templateName,
      "category": category,
      "language": language,
      "bodytext": bodyText,
      "header_type": headerType,
      "header_text": headerText,
      "header_upload": headerType === 'Text' ? '' : base64File,
      "footer_text": footerText,
      "quickactions": buttonsList,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === 'quickactions') {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (id == null) {
      const response = await createWhatsappTemplateApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          navigate(-1);
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "name": "",
            "category": "",
            "language": "",
            "bodytext": "",
            "header_type": "",
            "header_text": "",
            "header_upload": "",
            "footer_text": "",
            "quickactions": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateWhatsappTemplateApi(dataAfterSanitize, id);
      if (response.status === 200) {
        if (response.data.success === true) {
          navigate(-1);
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "name": "",
            "category": "",
            "language": "",
            "bodytext": "",
            "header_type": "",
            "header_text": "",
            "header_upload": "",
            "footer_text": "",
            "quickactions": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };




  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && ((headerType === 'Image' && file.type.startsWith("image/")) || (headerType === 'Video' && file.type.startsWith("video/")))) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;

        setBase64File(base64String)

      };
      reader.readAsDataURL(file);

    } else {
      alert("Please select a valid file.");
    }
  };

  return (<Container fluid className="main-container">
    <div style={{ width: "100vw" }}>
      <TopBar />
      <Row sm={12} className="main-row">
        <Col className="mx-2 " sm={12} style={{ padding: "16px" }}>
          <Row sm={12}>
            <Col sm={6} md={9}>
              <div className="style-justify-start">
                <div
                  onClick={() => {
                    navigate(-1);
                  }}
                  style={{
                    cursor: "pointer",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <BackIcon />
                </div>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#21272C",
                  }}
                >
                  Add whatsapp template
                </span>
              </div>
            </Col>
            <Col sm={6} md={3}>
              <div className="style-justify-end" style={{ gap: "8px" }}>
                <div
                  className="cancel_btn"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#21272C",
                    }}
                  >
                    Cancel
                  </div>
                </div>
                <div
                  className="success_btn"
                  onClick={() => {
                    submitWhatsappTemplate()
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#FFFFFF",
                    }}
                  >
                    Submit
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-3 ">
            <Col xs={12} sm={12} lg={8}>
              <div className="card-view mt-3">
                <Row style={{ display: "flex" }}>
                  <Col xs={12} sm={12}  >
                    <div className="field-title">
                      Template Name<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter here"
                      className="input-field mt-2 w-100"
                      value={templateName}
                      onChange={(event) => {
                        setTemplateName(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.name}</span>
                  </Col>

                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <div className="field-title">
                      Category<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <select className="select3 w-100 input-field mt-2" id="category" value={category} onChange={(event) => { setCategory(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                      <option value="">Select</option>
                      <option value="Authentication">Authentication</option>
                      <option value="Marketing">Marketing</option>
                      <option value="Utility">Utility</option>
                    </select>
                    <span className="field-error" >{validations.category}</span>
                  </Col>
                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <div className="field-title">
                      Language<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <select className="select3 w-100 input-field mt-2" id="language" value={language} onChange={(event) => { setLanguage(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                      <option value="">Select</option>
                      <option value="English (US)">English (US)</option>
                      <option value="Arabic">Arabic</option>
                      <option value="Spanish">Spanish</option>
                      <option value="Italic">Italic</option>
                      <option value="German">German</option>
                    </select>
                    <span className="field-error" >{validations.language}</span>
                  </Col>
                </Row>
                <div className="mt-3">
                  <div className="font-16-600-172B4D">
                    Header <span className="font-8-600-172B4D" style={{ color: '#FF4444' }}>*</span>
                  </div>
                  <div className="font-12-400-626F86 mt-1">Add a title or choose which type of media you’ll use for this tilte
                  </div>
                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <select className="select3 w-100 input-field mt-2" id="header_type" value={headerType} onChange={(event) => { setHeaderType(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                      <option value="">Select</option>
                      <option value="Text">Text</option>
                      <option value="Image">Image</option>
                      <option value="Video">Video</option>
                      <option value="Italic">Italic</option>
                      <option value="None">None</option>
                    </select>
                    <span className="field-error" >{validations.header_type}</span>
                  </Col>
                  {headerType === 'Text' && (<Col xs={12} sm={12} className="mt-2">
                    <textarea
                      type="text"
                      placeholder="Enter here"
                      className="input-field w-100"
                      value={headerText}
                      onChange={(event) => {
                        setHeaderText(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.header_text}</span>
                  </Col>)}
                  {(headerType === 'Image' || headerType === 'Video') && (<>
                    <div
                      className="proof-btn mt-2 style-justify-center"
                      style={{ background: '#D5FFE6', width: '126px' }}
                      onClick={handleFileClick}
                    >
                      <UploadIcon />
                      <div className="proof-btn-txt ">
                        Upload File
                      </div>
                    </div>

                    <input ref={fileInputRef}
                      type="file" accept={headerType === 'Video' ? "video/*" : ".jpg, .jpeg, .png"}
                      onChange={handleFileChange}
                      style={{ display: "none" }} // Hide the actual file input
                    />
                    <span className="field-error" >{validations.header_upload}</span>
                  </>)}
                </div>



                <div className="mt-3">
                  <div className="font-16-600-172B4D">
                    Body <span style={{ color: '#FF4444' }}>*</span>
                  </div>
                  <div className="font-12-400-626F86 mt-1">
                    Search here or You can add a variable in double curly brackets without a space to add a custom variables
                  </div>
                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <select className="select3 w-100 input-field mt-2" id="shift"
                      onChange={(event) => {
                        setBodyText(bodyText + " " + event.target.value);
                      }}
                      style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                      <option value="">Select</option>
                      <option value="{{name}}">{'{{name}}'}</option>
                      <option value="{{firstname}}">{'{{firstname}}'}</option>
                      <option value="{{lastname}}">{'{{lastname}}'}</option>
                      <option value="{{middlename}}">{'{{middlename}}'}</option>
                      <option value="{{supername}}">{'{{supername}}'}</option>
                      <option value="{{header name}}">{'{{header name}}'}</option>
                      <option value="{{narrator}}">{'{{narrator}}'}</option>
                    </select>

                  </Col>
                  <Col xs={12} sm={12} className="mt-2">
                    <textarea
                      type="text"
                      placeholder="Enter here"
                      className="input-field w-100"
                      value={bodyText}
                      onChange={(event) => {
                        setBodyText(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.bodytext}</span>
                  </Col>

                </div>

                <div className="mt-3">
                  <div className="font-16-600-172B4D">
                    Footer
                  </div>
                  <div className="font-12-400-626F86 mt-1">
                    Add a short line of text to the bottom of your message template
                  </div>

                  <Col xs={12} sm={12} className="mt-2">
                    <textarea
                      type="text"
                      placeholder="Enter here"
                      className="input-field w-100"
                      value={footerText}
                      onChange={(event) => {
                        setFooterText(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.footer_text}</span>
                  </Col>

                </div>


                <div className="mt-3">
                  <div className="font-16-600-172B4D">
                    Buttons
                  </div>
                  <div className="font-12-400-626F86 mt-1">
                    Create buttons that let customers respond to your message or take action
                  </div>
                  <Row className="style-justify-start">
                    <Col xs={12} sm={12} md={6} className="mt-2">
                      <select className="select3 w-100 input-field mt-2" id="shift" value={buttonName} onChange={(event) => { setButtonsList([]); setButtonName(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                        <option value="">Select</option>
                        <option value="None">None</option>
                        <option value="Call to action">Call to action</option>
                        <option value="Quick reply">Quick reply</option>

                      </select>
                      <span className="field-error" >{validations.shift}</span>
                    </Col>
                    <Col xs={12} sm={12} md={6} className="mt-2">
                      <div onClick={() => {
                        const tempButtons = [...buttonsList];
                        if (buttonName === 'Call to action') {
                          if (tempButtons.length === 0 || buttonsList.some(buttonObject => buttonObject.callActionType !== "Visit Website")) {
                            tempButtons.push({
                              "id": 0,
                              "button_type": buttonName, 'callActionType': 'Visit Website', "button_text": "", "visit_website": "", "call_button": "", "call_number": "", "url_type": "Static", "url_value": ""
                            });
                          }
                          if (tempButtons.length === 0 || buttonsList.some(buttonObject => buttonObject.callActionType !== "Call Phone")) {
                            tempButtons.push({
                              "id": 0,
                              "button_type": buttonName, 'callActionType': 'Call Phone', "button_text": "", "visit_website": "", "call_button": "", "call_number": "", "url_type": "", "url_value": ""
                            });
                          }
                          setButtonsList(tempButtons)
                        }
                        if (buttonName === 'Quick reply' && tempButtons.length === 0) {
                          tempButtons.push({
                            "id": 0,
                            "button_type": buttonName, 'callActionType': '', "button_text": "", "visit_website": "", "call_button": "", "call_number": "", "url_type": "", "url_value": ""
                          });
                          setButtonsList(tempButtons)
                        }
                        /*  if(buttonsList.length<2 && buttonsList.length!==1 && buttonName!==''){
                           const tempButtons=[...buttonsList];
                           tempButtons.push({
                             "id": 0,
                             "button_type": buttonName, 'callActionType': 'Visit Website',"button_text":"", "visit_website":"",  "call_button":"","call_number":"", "url_type": "Static", "url_value": ""
                           })
                           setButtonsList(tempButtons)
                         }else if(buttonsList.length===1){
                           const tempButtons=[...buttonsList];
                           if (buttonsList[0]['callActionType'] === 'Visit Website') {                                                   
                             tempButtons.push({
                               "id": 0,
                               "button_type": buttonName, 'callActionType': 'Call Phone',"button_text":"", "visit_website":"",  "call_button":"","call_number":"", "url_type": "", "url_value": ""
                             })
                            
                         }else{
                           tempButtons.push({
                             "id": 0,
                             "button_type": buttonName, 'callActionType': 'Visit Website',"button_text":"", "visit_website":"",  "call_button":"","call_number":"", "url_type": "", "url_value": ""
                           })                                                 
                         }
                         setButtonsList(tempButtons)
                         } */

                      }} className="proof-btn mt-2 style-justify-center"
                        style={{ background: '#D5FFE6', width: '126px', borderRadius: '8px', border: '1px solid #2C8C53' }} >
                        <div className="proof-btn-txt ">  Add button</div>
                      </div>
                    </Col>
                  </Row>
                  <div className="w-100">
                    {buttonsList.map((buttonType, index) => (
                      <div>
                        {buttonType.callActionType === 'Visit Website' && (<>

                          <div className="mt-3 w-100 style-justify-start" style={{ flex: 10 }}>
                            <div className="style-justify-center" style={{ flex: 2, background: '#F5F6F7', width: '126px', height: '40px', borderRadius: '8px', }}>
                              Visit Website
                            </div>
                            <div style={{ flex: 6, marginLeft: '12px' }}>
                              <input
                                type="text"
                                placeholder="Enter text"
                                className="input-field w-100"
                                value={buttonType.visit_website}
                                onChange={(event) => {
                                  const tempButtons = [...buttonsList];
                                  tempButtons[index].visit_website = event.target.value;
                                  setButtonsList(tempButtons)
                                }}
                              />
                            </div>
                            <div onClick={() => {
                              setButtonsList(btnItems => btnItems.filter(item => item.callActionType !== 'Visit Website'))
                            }} style={{ width: '40px', height: '40px', marginLeft: '12px', background: '#F5F6F7', borderRadius: '8px', }} className="style-justify-center" >
                              <img src={deleteIcon} style={{ width: "24px", height: "24px" }} />
                            </div>
                          </div>

                          <div className="mt-3 w-100 style-justify-start" style={{ flex: 10 }}>
                            <div style={{ flex: 2, }}>
                              <select className="select3 w-100 input-field " id="shift" value={buttonType.url_type}
                                onChange={(event) => {
                                  const tempButtons = [...buttonsList];
                                  tempButtons[index].url_type = event.target.value;
                                  setButtonsList(tempButtons)
                                }}
                                tyle={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                                <option value="Static">Static</option>
                                <option value="Dynamic">Dynamic</option>
                              </select>
                            </div>
                            <div style={{ flex: 6, marginLeft: '12px' }}>
                              <input
                                type="text"
                                placeholder="https://"
                                className="input-field w-100"
                                value={buttonType.url_value}
                                onChange={(event) => {
                                  const tempButtons = [...buttonsList];
                                  tempButtons[index].url_value = event.target.value;
                                  setButtonsList(tempButtons)
                                }}
                              />
                            </div>
                            <div style={{ width: '50px', }}  >

                            </div>
                          </div>
                        </>)}

                        {buttonType.callActionType === 'Call Phone' && (<div className="mt-3 w-100 style-justify-start" style={{ flex: 10 }}>
                          <div className="style-justify-center" style={{ flex: 2, background: '#F5F6F7', width: '126px', height: '40px', borderRadius: '8px', }}>
                            Call Phone
                          </div>
                          <div style={{ flex: 3, marginLeft: '12px' }}>
                            <input
                              type="text"
                              placeholder="Enter text"
                              className="input-field w-100"
                              value={buttonType.call_button}
                              onChange={(event) => {
                                const tempButtons = [...buttonsList];
                                tempButtons[index].call_button = event.target.value;
                                setButtonsList(tempButtons)
                              }}
                            />
                          </div>

                          <div style={{ flex: 3, marginLeft: '12px' }}>
                            <input
                              type="text"
                              placeholder="Phone number"
                              className="input-field w-100"
                              value={buttonType.call_number}
                              onChange={(event) => {
                                const tempButtons = [...buttonsList];
                                tempButtons[index].call_number = event.target.value;
                                setButtonsList(tempButtons)
                              }}
                            />
                          </div>
                          <div onClick={() => {
                            setButtonsList(btnItems => btnItems.filter(item => item.callActionType !== 'Call Phone'))
                          }} style={{ width: '40px', height: '40px', marginLeft: '12px', background: '#F5F6F7', borderRadius: '8px', }} className="style-justify-center" >
                            <img src={deleteIcon} style={{ width: "24px", height: "24px" }} />
                          </div>
                        </div>)}
                      </div>))}
                    {buttonName === 'Quick reply' && buttonsList.map((buttonType, index) => (
                      <div>
                        <div className="mt-3 w-100 style-justify-start" style={{ flex: 10 }}>

                          <div style={{ flex: 4, marginLeft: '12px' }}>
                            <input
                              type="text"
                              placeholder="Enter button text"
                              className="input-field w-100"
                              value={buttonType.button_text}
                              onChange={(event) => {
                                const tempButtons = [...buttonsList];
                                tempButtons[index].button_text = event.target.value;
                                setButtonsList(tempButtons)
                              }}
                            />
                          </div>


                          <div onClick={() => { setButtonsList([]) }} style={{ width: '40px', height: '40px', marginLeft: '12px', background: '#F5F6F7', borderRadius: '8px', }} className="style-justify-center" >
                            <img src={deleteIcon} style={{ width: "24px", height: "24px" }} />
                          </div>
                          <div style={{ flex: 5, marginLeft: '12px' }}></div>
                        </div>
                      </div>))}
                  </div>

                </div>

              </div>

            </Col>
            <Col xs={12} sm={12} lg={4}></Col>
          </Row>
        </Col>
      </Row>
    </div>
    <ToastContainer position="top-end">
      <Toast
        className="d-inline-block m-1"
        bg={snackbarStatus === true ? "success" : "danger"}
        show={showSnackbar}
        onClose={handleSnackbarClose}
        delay={3000}
        autohide
      >
        <Toast.Body style={{ color: "#ffffff" }}>
          {snackbarMessage}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  </Container>);

}

